import { SensorConversions } from "../conversionFunctions/sensorConversions.js";
import { SensorElementConfig } from "./types.js";

export const pulseTotalizerElementConfig: SensorElementConfig<Record<string, never>, typeof SensorConversions.unity> = {
    legalConvertedRange: [0, null],
    conversionKey: "unity",
    parameterConfigs: {},
    buildConversionParams: () => ({}),
    decodedUnits: "pulse",
    convertedUnits: "pulse",
    unitCategory: "electricalPulseCount",
    testCases: [
        { parameters: {}, decodedValue: 0, convertedValue: 0 },
        { parameters: {}, decodedValue: 100, convertedValue: 100 },
    ],
} as const;
